import { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { PAGE_TITLE_CLASS } from './ContentPageHeader';
import { PAGE_GUTTERS, PAGE_MAX_WIDTH, pageBleedXClass } from './PageContainer';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
  filters?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, actions, filters, className }: PageHeaderProps) {
  return (
    <div className={cn('bg-primary text-primary-foreground', pageBleedXClass, className)}>
      <div className={cn('mx-auto w-full min-w-0', PAGE_MAX_WIDTH, PAGE_GUTTERS, 'py-4')}>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex min-w-0 flex-col gap-1">
            <h1 className={cn(PAGE_TITLE_CLASS, 'min-w-0 break-words')}>
              {title}
            </h1>
            {description && (
              <p className="text-sm text-primary-foreground/80">
                {description}
              </p>
            )}
          </div>
          {(actions || filters) && (
            <div className="flex w-full min-w-0 flex-wrap items-center gap-2 sm:w-auto sm:flex-nowrap sm:gap-3">
              {filters}
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
